const warning = ({count}) => {
    return (
        <li>
            <div className="layout_view vaguesearch">Limited Results Displayed - Found {count} results!</div>
        </li>
    )
}
export default warning;